import React from 'react';
import cn from 'classnames';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { BubbleArrow, Approved, Hotel } from '@lt/components/icons-react';

import { convertServerDateToClientDate } from 'src/utils/dateUtils';

import ReviewShowMore from 'src/components/Reviews/ReviewShowMore';
import { HotelRatingSquare } from '@lt/components';

const baseCls = 'lt-hotel-reviews-item';
const baseClsHotelReply = `${baseCls}__hotelreply`;

// LT-39132 Старый компонент удалить при интеграции новой карточки отзывов
export interface IReviewsItem {
  content: string;
  author_id?: string;
  author_image: string;
  created_at: string;
  average_rating: number;
  initials: string;
  phrase: string;
  answered_at?: string;
  answer: string | null;
}

export type IReviewsItemContainer = IReviewsItem & {
  showDate: boolean;
  maxContainerHeight?: number;
  maxContentLength?: number;
  showExpandButton?: boolean;
  isMobile?: boolean;
};

const ReviewsItem = (props: IReviewsItemContainer) => {
  const {
    content,
    author_image,
    created_at,
    average_rating,
    initials,
    phrase,
    answered_at,
    answer,
    showDate = false,
    maxContainerHeight,
    maxContentLength,
    showExpandButton = true,
    isMobile = false,
    author_id,
  } = props;

  const { t } = useTranslation();

  const reviewDate = convertServerDateToClientDate(created_at);
  const answerDate = convertServerDateToClientDate(answered_at);

  return (
    <div
      className={cn(`${baseCls} lt-paper`, {
        [`${baseCls}__last`]: !showDate,
        [`${baseCls}--mobile`]: isMobile,
      })}
      key={author_id}
    >
      <div className={`${baseCls}__title`}>
        <div className={`${baseCls}__profile-img`}>
          <img src={author_image} alt={initials} />
        </div>
        <div className={`${baseCls}__shortdesc`}>
          <StyledHotelRatingSquare
            value={average_rating}
            count={average_rating}
            size="small"
          />
          <h4
            className={cn(`${baseCls}__name like-h4`, {
              [`${baseCls}__name--mobile`]: isMobile,
            })}
          >
            {initials}
          </h4>
          <span
            className={cn(`${baseCls}__dest`, {
              [`${baseCls}__dest--mobile`]: isMobile,
            })}
          >
            {phrase}
          </span>
        </div>
        {showDate && <span className={`${baseCls}__date`}>{reviewDate}</span>}
      </div>
      <div
        className={cn(`${baseCls}__content`, {
          [`${baseCls}__content--last`]: showDate,
          [`${baseCls}__content--mobile`]: isMobile,
        })}
      >
        <ReviewShowMore
          content={content || ''}
          maxContainerHeight={maxContainerHeight}
          maxContentLength={maxContentLength}
          showExpandButton={showExpandButton}
        />
      </div>
      {answer && showDate && (
        <div className={baseClsHotelReply}>
          <BubbleArrowIcon />
          <div className={`${baseClsHotelReply}__title`}>
            <HotelIcon />
            <h4 className={`${baseClsHotelReply}__name like-h4`}>
              {t('hotel.reviews.hotelReplyTitle')}
            </h4>
            <ApprovedIcon />
            {showDate && (
              <span className={`${baseCls}__date`}>{answerDate}</span>
            )}
          </div>
          <div
            className={cn(`${baseClsHotelReply}__content`, {
              [`${baseClsHotelReply}__content--mobile`]: isMobile,
            })}
          >
            <ReviewShowMore
              content={answer}
              maxContainerHeight={maxContainerHeight}
              maxContentLength={maxContentLength}
              showExpandButton
              overlayColor="#f3f2e8"
            />
          </div>
        </div>
      )}
    </div>
  );
};

const BubbleArrowIcon = styled(BubbleArrow)`
  width: 26px;
  height: 12px;

  top: '-12px';
  position: 'absolute';
`;

const HotelIcon = styled(Hotel)`
  width: 20px;
  height: 16px;
`;

const ApprovedIcon = styled(Approved)`
  width: 16px;
  height: 16px;

  margin-left: 7px;
`;

const StyledHotelRatingSquare = styled(HotelRatingSquare)`
  margin-left: 10px;
`;

export default ReviewsItem;
